import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { Button } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-wizard-header',
  standalone: true,
  imports: [Button, TranslocoModule],
  templateUrl: './wizard-header.component.html',
  styleUrl: './wizard-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizardHeaderComponent {
  readonly currentStep = input.required<number>();
  readonly totalSteps = input<number>(3);
  readonly title = input<string>('');
  readonly isViewMode = input<boolean>(false);

  readonly cancel = output<void>();

  onCancel(): void {
    this.cancel.emit();
  }
}
